import React, { useState } from 'react';

// material
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Card, Box, Grid, Typography, Divider,
  Stack, Tooltip, Skeleton, useTheme, useMediaQuery
} from '@mui/material';








// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: "#FFFFFF"
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));


const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "100px",
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
    marginBottom: '10px'
  },
});


// ----------------------------------------------------------------------

let TOTAL = 0;

if (process.env.REACT_APP_ENVIRONMENT === "development")
  TOTAL = 800






export default function SoundBoxStatsItem({ statsData, loading }) {

  const [expanded, setExpanded] = useState(false);

  const classes = useStyles();

  const theme = useTheme();
  const isMediumUp = useMediaQuery(theme.breakpoints.up('md'));


  return (
    <Box>


      <Grid container spacing={{md:1, sm:1, xs:1.75}} justifyContent="center" sx={{ minHeight: '12vh' }}>

        <Grid item xs={6} md={2}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}>

              <Tooltip title={loading ? "" :statsData?.day_summary?.totalAmount} arrow>
                {
                  loading ? (
                  <Skeleton variant="rounded" sx={{ fontSize: '26px', width: '80px', height: '30px'}}/>
                  ) :(
                    <Typography sx={{ fontWeight: 600, color: "#6F6F6F", fontSize: {md:"26px", sm:"26px", xs:"24px"}, lineHeight: "30px" }}> {statsData?.day_summary?.totalAmount !== undefined ? "₹ " : ""} {fShortenNumber(statsData?.day_summary?.totalAmount)}</Typography>
                  )
                }
            </Tooltip>

            <Tooltip title="Sum of all day transactions *Resets at 12 AM" arrow>
            <Typography sx={{ fontWeight: 700, color: "#171D40", fontSize: "14px", lineHeight: "14px", textAlign: 'center' }}>Total Amount </Typography>
          </Tooltip>

          </Stack>
        </Grid>

        {/* <Grid item xs={.3} md={.3}>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.2)' }} orientation='vertical' />
        </Grid> */}

        {isMediumUp && (
              <Grid item md={0.5} mt={1} mb={1}>
                <Divider
                  sx={{
                    borderColor: 'rgba(0, 0, 0, 0.2)',
                  }}
                  orientation="vertical"
                />
              </Grid>
        )}

        <Grid item xs={6} md={2}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}>
            <Tooltip title={loading? "" : statsData?.day_summary?.notificationMissed} arrow>
              {
                loading ? (
                  <Skeleton variant="rounded" sx={{ fontSize: '26px', width: '80px', height: '30px'}}/>
                ) : (
                  <Typography sx={{ fontWeight: 600, color: "#6F6F6F", fontSize: {md:"26px", sm:"26px", xs:"24px"}, lineHeight: "30px" }}>{fShortenNumber(statsData?.day_summary?.notificationMissed)}</Typography>
                )
              }
            </Tooltip>
            <Tooltip title="Number of payment requests missed due to device offline/switch off  * Resets at 12 AM" arrow>
            <Typography sx={{ fontWeight: 700, color: "#171D40", fontSize: "14px", lineHeight: "14px", textAlign: 'center' }}>Messages Missed </Typography>
            </Tooltip>

          </Stack>
        </Grid>

        {/* <Grid item xs={.3} md={.3}>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.2)' }} orientation='vertical' />
        </Grid> */}

        {isMediumUp && (
              <Grid item md={0.5} mt={1} mb={1}>
                <Divider
                  sx={{
                    borderColor: 'rgba(0, 0, 0, 0.2)',
                  }}
                  orientation="vertical"
                />
              </Grid>
        )}


        <Grid item xs={6} md={2}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}>
            <Tooltip title={loading ? "" : statsData?.day_summary?.messagesSent} arrow>
              {
                loading ? (
                  <Skeleton variant="rounded" sx={{ fontSize: '26px', width: '80px', height: '30px'}}/>
                ) : (
                  <Typography sx={{ fontWeight: 600, color: "#6F6F6F", fontSize: {md:"26px", sm:"26px", xs:"24px"}, lineHeight: "30px" }}>{fShortenNumber(statsData?.day_summary?.messagesSent)}</Typography>
                )
              }
            </Tooltip>

            <Tooltip title="Number of payment requests sent to device from bank throughout the day *Resets at 12 AM" arrow>
            <Typography sx={{ fontWeight: 700, color: "#171D40", fontSize: "14px", lineHeight: "14px", textAlign: 'center' }}>Messages Sent </Typography>
            </Tooltip>

          </Stack>
        </Grid>

        {/* <Grid item xs={.3} md={.3}>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.2)' }} orientation='vertical' />
        </Grid> */}

        {isMediumUp && (
              <Grid item md={0.5} mt={1} mb={1}>
                <Divider
                  sx={{
                    borderColor: 'rgba(0, 0, 0, 0.2)',
                  }}
                  orientation="vertical"
                />
              </Grid>
        )}

        <Grid item xs={6} md={2}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}>

            <Tooltip title={loading ? "" : statsData?.day_summary?.messagesDelivered} arrow>
              {
                loading ? (
                  <Skeleton variant="rounded" sx={{ fontSize: '26px', width: '80px', height: '30px'}}/>
                ) :(
                  <Typography sx={{ fontWeight: 600, color: "#6F6F6F", fontSize: {md:"26px", sm:"26px", xs:"24px"}, lineHeight: "30px" }}>{fShortenNumber(statsData?.day_summary?.messagesDelivered)}</Typography>
                )
              }
            </Tooltip>

            <Tooltip title="Number of payment requests successfully announced by the device throughout the day *Resets at 12 AM" arrow>
            <Typography sx={{ fontWeight: 700, color: "#171D40", fontSize: "14px", lineHeight: "14px", textAlign: 'center' }}>Messages Delivered </Typography>
            </Tooltip>
          </Stack>
        </Grid>

        {/* <Grid item xs={.3} md={.3}>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.2)' }} orientation='vertical' />
        </Grid> */}

        {isMediumUp && (
              <Grid item md={0.5} mt={1} mb={1}>
                <Divider
                  sx={{
                    borderColor: 'rgba(0, 0, 0, 0.2)',
                  }}
                  orientation="vertical"
                />
              </Grid>
        )}

        <Grid item xs={6} md={2}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}>
            <Tooltip title={loading ? "" : statsData?.day_summary?.totalTransaction} arrow>
              {
                loading ? (
                  <Skeleton variant="rounded" sx={{ fontSize: '26px', width: '80px', height: '30px'}}/>
                ) : (
                  <Typography sx={{ fontWeight: 600, color: "#6F6F6F", fontSize: {md:"26px", sm:"26px", xs:"24px"}, lineHeight: "30px" }}>{fShortenNumber(statsData?.day_summary?.totalTransaction)}</Typography>
                )
              }
            </Tooltip>

            <Tooltip title="Total number of transactions done throughout the day *Resets at 12 AM" arrow>
            <Typography sx={{ fontWeight: 700, color: "#171D40", fontSize: "14px", lineHeight: "14px", textAlign: 'center' }}>Total no. of Transactions </Typography>
            </Tooltip>

          </Stack>
        </Grid>
      </Grid>







    </Box>
  );
}
